import React from "react";
import { useAppSelector } from "../../../../../app/hooks"
import { TextField } from "@mui/material";
import { formatNumber } from "@progress/kendo-intl";

function AccountContractualAdjustmentView(){
    const account = useAppSelector((state) => state.account.account);
    return <React.Fragment>
        <TextField label='Contractual Adjustment' 
            value={formatNumber(account.transactionHeader.contractualAdjustments,'c')}
            disabled
            />
    </React.Fragment>
}
export {AccountContractualAdjustmentView}